import api from "@/lib/api";

// Portal-side "inactive" drivers: the shared Fleet API can't store this, so it lives in the portal backend.
export const pausedDriverIds = () => api.get("/driver-tools/paused").then((r) => new Set(r.data.driver_ids || [])).catch(() => new Set());
export const setDriverPaused = (driverId, paused) => api.post("/driver-tools/pause", { driver_id: driverId, paused });
